import { makeStyles, Chip, ListItem } from "@material-ui/core";
import { useEffect, useState } from "react";

const enterAnimationLength = 220;
const exitAnimationLength = 220;

const useStyles = makeStyles({
    root: {
        border: ({hasError}: IChipItem) => `1px solid ${hasError ? 'red' : 'transparent'}`,
        padding: "0.25rem",
        backgroundColor: "#F1F1F1",
        borderRadius: "0.7rem",
        margin: "0.4rem",
        display: "inline-block",
        fontSize: "1rem",
        fontStyle: "italic"

    },
    listItem: {
        width: "auto",
        paddingLeft: "0.3rem",
        paddingRight: "0.3rem"
    },
    removeIcon: {
        borderRadius: "50px",
        backgroundColor: "#FFF",
        padding: "0.25rem",
        cursor: "pointer"
    },
    chip: {
        backgroundColor: "#FFFFFF",
        
    },
    chipError: {
        backgroundColor: "#FFEEEE",
        border: "1px solid #F52D5C"
    },
    chipEnter: {
        animation: `$animateIn ${enterAnimationLength}ms ease-in-out`
    },
    chipExit: {
        animation: `$animateOut ${exitAnimationLength}ms ease-in-out`
    },
    "@keyframes animateIn": {
        "0%": {
          transform: "scaleY(0.8) scaleX(0.85)"
        },
        "75%": {
            transform: "scaleY(1.15) scaleX(1.1)"
        },
        "100%": {
            transform: "scaleY(1) scaleX(1)"
        }
    },
    "@keyframes animateOut": {
        "0%": {
          transform: "scaleY(1) scaleX(1)"
        },
        "75%": {
            transform: "scaleY(1.1) scaleX(1.1)"
        },
        "100%": {
            transform: "scaleY(0.2) scaleX(0.2)"
        }
    },
})

export interface IChipItem {
    displayText: string;
    hasError?: boolean;
    isEditable?: boolean;
    onRemove?: () => void;
    onChange?: (value: string) => void;
}

const ChipItem = (props: IChipItem) => {

    const classes = useStyles(props);

    const [ isExiting, setIsExiting ] = useState(false);
    const [ isEntering, setIsEntering ] = useState(false);

    const { displayText, onRemove, hasError, isEditable } = props;

    const onClickRemove = () => {
        setIsExiting(true);
        if(onRemove){
            setTimeout(
                () => {
                    onRemove();
                    setIsExiting(false);
                }
            , exitAnimationLength);
        }
    }

    useEffect(() => {
        setIsEntering(true);
        setTimeout(
            () => {
                setIsEntering(false);
            }
        , enterAnimationLength);
    }, [])

    return (
        <ListItem className={classes.listItem}>
            <Chip 
                className={`
                    ${classes.chip}
                    ${hasError && classes.chipError}
                    ${isExiting && classes.chipExit}
                    ${isEntering && classes.chipEnter}
                `}
                label={displayText}
                variant="outlined"
                onDelete={onClickRemove}
                clickable={isEditable}
            />
        </ListItem>
        
    )
}

export default ChipItem;